import { useBusinessesViewsListBusinessesQuery } from "../airloom-generated-rtk";

export const useBusinesses = () => {
  const { data, isLoading, isError, refetch } =
    useBusinessesViewsListBusinessesQuery({ accessLevel: undefined });

  return {
    businesses: data?.businesses,
    loading: isLoading,
    error: isError,
    refetch: refetch,
  };
};
